import React from 'react';
/** Provides access to the Analytics reporter object */
export var AnalyticsContext = React.createContext(null);
/** Provides access to commonly used MusicPlayer APIs (without exposing the entire player) */
export var PlayerUtilsContext = React.createContext({
    getPlaybackEvents: function () { return []; },
    getTracksMetadata: function () { return ({}); },
    getLastMeasure: function () { return 0; }
});
